import { c as _c } from "react/compiler-runtime";
import type { KeyboardEvent, RefObject } from "react";
export default function CreateWaveGroupSearchInput(t0) {
  const $ = _c(30);
  const {
    inputRef,
    inputId,
    listboxId,
    activeOptionId,
    label,
    value,
    isOpen,
    disabled,
    hasValue,
    hasSelectedGroup,
    showClearButton,
    onInputFocus,
    onInputChange,
    onInputKeyDown,
    onClearSelection
  } = t0;
  const t1 = disabled ? "tw-bg-iron-900/80 tw-text-iron-500 tw-caret-iron-500 placeholder:tw-text-iron-500" : "tw-caret-primary-400 placeholder:tw-text-iron-500 hover:tw-ring-white/10 focus:tw-border-primary-400 focus:tw-bg-iron-950 focus:tw-ring-primary-400";
  const t2 = hasValue || hasSelectedGroup ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white";
  let t3;
  if ($[0] !== t1 || $[1] !== t2) {
    t3 = ["tw-form-input tw-peer tw-block tw-w-full tw-appearance-none tw-rounded-lg tw-border-0 tw-bg-iron-950 tw-pb-3 tw-pl-10 tw-pr-4 tw-pt-3 tw-text-base sm:tw-text-sm tw-font-medium tw-shadow-inner tw-ring-1 tw-ring-inset tw-ring-white/5 tw-transition tw-duration-300 tw-ease-out", t1, t2];
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const inputClasses = t3.join(" ");
  let t4;
  if ($[3] !== onInputChange) {
    t4 = event => onInputChange(event.target.value);
    $[3] = onInputChange;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== activeOptionId || $[6] !== disabled || $[7] !== inputClasses || $[8] !== inputId || $[9] !== inputRef || $[10] !== isOpen || $[11] !== listboxId || $[12] !== onInputFocus || $[13] !== onInputKeyDown || $[14] !== t4 || $[15] !== value) {
    t5 = <input ref={inputRef} id={inputId} type="text" role="combobox" aria-autocomplete="list" aria-expanded={isOpen} aria-controls={listboxId} aria-disabled={disabled} aria-activedescendant={activeOptionId} value={value} onFocus={onInputFocus} onChange={t4} onKeyDown={onInputKeyDown} placeholder=" " disabled={disabled} className={inputClasses} autoComplete="off" />;
    $[5] = activeOptionId;
    $[6] = disabled;
    $[7] = inputClasses;
    $[8] = inputId;
    $[9] = inputRef;
    $[10] = isOpen;
    $[11] = listboxId;
    $[12] = onInputFocus;
    $[13] = onInputKeyDown;
    $[14] = t4;
    $[15] = value;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  let t6;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <svg className="tw-pointer-events-none tw-absolute tw-left-3 tw-top-3.5 tw-h-5 tw-w-5 tw-text-iron-500" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fillRule="evenodd" d="M9 3.5a5.5 5.5 0 100 11 5.5 5.5 0 000-11zM2 9a7 7 0 1112.452 4.391l3.328 3.329a.75.75 0 11-1.06 1.06l-3.329-3.328A7 7 0 012 9z" clipRule="evenodd" /></svg>;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== hasSelectedGroup || $[19] !== onClearSelection || $[20] !== showClearButton) {
    t7 = showClearButton && <button type="button" onClick={onClearSelection} aria-label={hasSelectedGroup ? "Clear selected group" : "Clear search"} className="tw-absolute tw-right-3 tw-top-3.5 tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-border-0 tw-bg-transparent tw-p-0 tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out hover:tw-text-error"><svg className="tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg></button>;
    $[18] = hasSelectedGroup;
    $[19] = onClearSelection;
    $[20] = showClearButton;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const t8 = `tw-absolute tw-cursor-text tw-rounded-lg tw-text-base tw-font-medium ${disabled ? "tw-text-iron-400" : "tw-text-iron-500"} tw-start-1 tw-top-2 tw-z-10 tw-ml-7 tw-origin-[0] -tw-translate-y-4 tw-scale-75 tw-transform tw-bg-iron-950 tw-px-2 tw-duration-300 peer-placeholder-shown:tw-top-1/2 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-scale-100 peer-focus:tw-top-2 peer-focus:-tw-translate-y-4 peer-focus:tw-scale-75 peer-focus:tw-bg-iron-950 peer-focus:tw-px-2 peer-focus:tw-text-primary-400 rtl:peer-focus:tw-left-auto rtl:peer-focus:tw-translate-x-1/4`;
  let t9;
  if ($[22] !== inputId || $[23] !== label || $[24] !== t8) {
    t9 = <label htmlFor={inputId} className={t8}>{label}</label>;
    $[22] = inputId;
    $[23] = label;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t5 || $[27] !== t7 || $[28] !== t9) {
    t10 = <div className="tw-relative">{t5}{t6}{t7}{t9}</div>;
    $[26] = t5;
    $[27] = t7;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  return t10;
}